import { useImageUrl } from '@/hooks/useImageUrl';
import { CaretDownOutlined } from '@ant-design/icons';
import { useLocation, useModel } from '@umijs/max';
import { Avatar, Layout, Space } from 'antd';
import React from 'react';
import menuToggle from '../../../public/icons/menu-toggle.svg';
import { Notification, SystemPortal } from '../RightContent';
import { AvatarDropdown, AvatarName } from '../RightContent/AvatarDropdown';
const { Header: AntHeader } = Layout;

interface HeaderProps {
  currentUser?: API.UserData;
  setCollapsed: (collapsed: boolean) => void;
  collapsed: boolean;
  currentModule: any;
}

const Header: React.FC<HeaderProps> = ({ setCollapsed, collapsed, currentModule }) => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  //@ts-ignore
  const { imgUrl } = useImageUrl({ filePath: currentUser?.userProfile?.avatar || null });
  return (
    <AntHeader
      className='desktop-header'
      style={{
        background: '#0060AF',
        padding: '0px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 4px rgba(0,21,41,.08)',
        color: '#fff',
        height: '62px',
        // borderLeft: '1px solid #fff',
        position: 'fixed',
        top: 0,
        left: collapsed ? '64px' : '256px',
        right: 0,
        zIndex: 1000,
        transition: '0.2s',
      }}
    >
      <div className='header-left'>
        {!isHomePage && (
          <img
            src={menuToggle}
            alt='logo'
            onClick={() => setCollapsed(!collapsed)}
            style={{ cursor: 'pointer' }}
          />
        )}
        {currentModule?.name}
      </div>
      <Space size='middle'>
        <Notification />
        <SystemPortal />
        <AvatarDropdown>
          <Space size={12} style={{ cursor: 'pointer' }}>
            <Avatar src={imgUrl} size={40} style={{ backgroundColor: '#E5E7EB' }} />
            <AvatarName />
            <CaretDownOutlined style={{ fontSize: '16px' }} />
          </Space>
        </AvatarDropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
